import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight';
import React from 'react';
import { useTheme } from 'styled-components';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Text } from '../typography';
import { AboutList, AboutListItem, LegalAbout, LegalAboutTitle } from './LegalFeesCalculator.style';

interface LegalFeesAboutProps {}

const LegalFeesAbout: React.FC<LegalFeesAboutProps> = () => {
  const theme = useTheme();
  return (
    <LegalAbout>
      <LegalAboutTitle fontSize={20} mb={20} fontWeight="bold" color={theme.textDark}>
        Why use Millar McCall Wylie?
      </LegalAboutTitle>

      <AboutList>
        {[
          "One of Northern Ireland's leading law firms",
          'Trusted to provide legal services for a wide range of clients',
          'High quality, cost-effective service for homeowners',
          'Work alongside all major UK lenders',
        ].map((text) => (
          <AboutListItem key={text}>
            <FontAwesomeIcon color={theme.primary} icon={faArrowRight} size={22} />
            <Text fontSize={18} color={theme.textDark}>
              {text}
            </Text>
          </AboutListItem>
        ))}
      </AboutList>
    </LegalAbout>
  );
};

export default LegalFeesAbout;
